export default "__VITE_ASSET__BpM7I07Q__"